import { Box, Button, Grid, Menu, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import ButtonSelectInput from "../../components/ButtonSelectInput";
import CustomPagination from "../../components/CustomPagination";
import MyDateRangePicker from "../../components/MyDateRangePicker";
import StyledTable from "../../components/StyledTable";
import { agentActions } from "../../store/actions";
import Layout from "../Layout";
import { formatEndDateForApi, formatStartDateForApi } from "../../utils/misc";

export default function TransactionReport() {
    const headers = [
        {
            key: "date",
            title: "Date",
        },
        {
            key: "name",
            title: "Name"
        },
        {
            key: "agenttype",
            title: "User Type"
        },
        {
            key: "topupamount",
            title: "Amount"
        },
        {
            key: "commission",
            title: "Commission"
        },
        {
            key: "totalamount",
            title: "Total Amount"
        }
    ];

    const { unitTopupHistoryCount ,unitTopupHistory, unitWithdrawHistoryCount ,unitWithdrawHistory } = useSelector((state) => state.agentManagement);

    const dispatch = useDispatch();

    const fetchData = () => {
        if (value.startDate && value.endDate) {
            dispatch(agentActions.getUnitHistory({channel:"agent", type: "topup", page, startDate: formatStartDateForApi(value?.startDate), endDate: formatEndDateForApi(value?.endDate)}));
            dispatch(agentActions.getUnitHistory({channel: "agent", type: "withdraw", page, startDate: formatStartDateForApi(value?.startDate), endDate: formatEndDateForApi(value?.endDate)}));
        } else {
            dispatch(agentActions.getUnitHistory({channel:"agent", type: "topup", page}));
            dispatch(agentActions.getUnitHistory({channel: "agent", type: "withdraw", page}));        
        }
    }

    const [page, setPage] = useState(1);

    const handlePageChange = (e, value) => {
        setPage(value);
    }

    const [datepickerAnchorEl, setDatePickerAnchorEl] = useState(null);
    const open = Boolean(datepickerAnchorEl);
    const [value, setValue] = useState({});

    const toggleDatePicker = (e) => {
        if (datepickerAnchorEl !== null) {
            setDatePickerAnchorEl(null);
        } else {
            setDatePickerAnchorEl(e.currentTarget)
        }
    }

    useEffect(() => {
        fetchData();
    }, [value, page])

    const items = ["Topup", "Withdraw"];

    const [selectedItem, setSelectedItem] = useState(items[0]);

    const handleSelectChange = (e, value) => {
        setSelectedItem(e.target.value);
    }

    useEffect(() => {
        setPage(1);
    }, [selectedItem])

    return (
        <Layout>
            <Grid container spacing={2} sx={{ alignItems: "center", mb: '1rem' }}>
                <Grid item
                sx={{ flexGrow: 1 }}
                >
                    <Typography variant="h5" sx={{ fontWeight: "500" }}>Transaction Report</Typography>
                </Grid>
                <Grid item>
                    <ButtonSelectInput items={items} selected={selectedItem} onChange={handleSelectChange} />
                </Grid>
                <Grid item>
                    <Button onClick={toggleDatePicker} variant="contained" color="primary">Filter by date</Button>
                </Grid>
            </Grid>
            <Menu
                anchorEl={datepickerAnchorEl}
                open={open}
                // onClose={toggleDatePicker}
                sx={{
                    mt: "10px",
                    "& .MuiPaper-root": {
                        minWidth: "0px",
                        minHeight: "0px"
                    },
                    "& ul": {
                        padding: 0,
                    }
                }}
            >
                <MyDateRangePicker open={open} toggle={toggleDatePicker} value={value} setValue={setValue} />
            </Menu>
            {(value.startDate && value.endDate) && (
                <Grid container spacing={2} sx={{ alignItems: "center", mb: '1rem' }}>
                <Grid item
                sx={{ flexGrow: 1 }}
                >
                    <Typography>{"From "+new Date(value?.startDate).toLocaleDateString() +" To "+new Date(value?.endDate).toLocaleDateString()}</Typography>
                </Grid>
                <Grid item>
                    <Button onClick={() => setValue({})} variant="contained" color="primary">Clear</Button>
                </Grid>
            </Grid>
            )}
            <StyledTable
            sx={{mt: '2rem', backgroundColor: "transparent"}}
            headers={headers}
            data={(selectedItem == "Topup")? unitTopupHistory: unitWithdrawHistory}
            />
            <CustomPagination
            handlePageChange={handlePageChange}
            page={page}
            perPage={10}
            dataCount={(selectedItem == "Topup")? unitTopupHistoryCount: unitWithdrawHistoryCount}
            />
        </Layout>
    );
}